module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "glo"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Glossary of Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Aktions")]), _vm._v(" – The removal of Jews, Gypsies and other ‘enemies’ of the Third Reich to the concentration camps.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Aliyah Bet")]), _vm._v(" – The codename given to the illegal immigration of Jews to Palestine in the 1930s and 40s.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Appell")]), _vm._v(" – Roll-call at the camps.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Appellplatz")]), _vm._v(" – The square where prisoners would assemble for roll-call.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Arschlöcher")]), _vm._v(" – German insult; arsehole.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Asos")]), _vm._v(" – Short for ‘antisocial ones’ – a category of prisoners including the homeless, long-term unemployed, sex offenders etc.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Baumeisters")]), _vm._v(" – Civilian engineers (see also "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Steigers")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Bedzin – Author’s home town.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Berchtesgaden – Hitler’s Bavarian retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Berufsverbrecher")]), _vm._v(" – Professional criminals who worked in the camps.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Blockältester")]), _vm._v(" – Block senior.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Blockschreiber")]), _vm._v(" – Roll-call clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Blocksperre")]), _vm._v(" – Lock-down.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Byelorussia – Belarus.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dreckjuden!")]), _vm._v(" – German insult; ‘Dirt Jew!’")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Edelweiss Piraten")]), _vm._v(" – Anti-Nazi movement in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Einsatzgruppe")]), _vm._v(" – German taskforce, execution squad.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Eretz Yisrael")]), _vm._v(" – The Biblical Land of Israel; Greater Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Fall Weiss")]), _vm._v(" – The Nazi’s strategic plan for invading Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Familienlager")]), _vm._v(" – Family camp.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gau")]), _vm._v(" – German district.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gauleiter")]), _vm._v(" – District leader.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gordonia")]), _vm._v(" – A Zionist youth movement.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hachshara")]), _vm._v(" – Preparation for emigration to Palestine/Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Häftlingskrankenbau")]), _vm._v(" – Prisoners’ hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Haganah – Jewish Defence Force; paramilitary organisation.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hausfrau")]), _vm._v(" – Housewife.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Heder")]), _vm._v(" – Religious primary school.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hefker")]), _vm._v(" – Jewish term for being free of responsibilities; from the legal term to denote an ownerless property.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hitlerjugend")]), _vm._v(" – Hitler Youth.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jedem das Seine")]), _vm._v(" – ‘To each, his own’ – motto on gates of Mauthausen camp.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Judenfieber")]), _vm._v(" – Typhus; lit. ‘Jew fever’.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Judenrat")]), _vm._v(" – Jewish council.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Judenrein")]), _vm._v(" – Cleansed of Jews.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kaddish")]), _vm._v(" – Jewish prayer for the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kapos")]), _vm._v(" – Camp foremen, recruited from the ranks of the prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kappellmeister")]), _vm._v(" – Bandmaster.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kindertransporte")]), _vm._v(" – The transport of children – either to safety, or to the death camps.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Knochenmühle")]), _vm._v(" – ‘The bone-grinder’ – nickname for Mauthausen camp.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kojen")]), _vm._v(" – Three-tiered bunk.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kommando")]), _vm._v(" – German term for unit.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kriegsmarine")]), _vm._v(" – German Navy.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lagerälteste")]), _vm._v(" – Camp seniors.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lagerführer")]), _vm._v(" – Camp commandant.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lagerschreiber")]), _vm._v(" – Camp clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lausbub")]), _vm._v(" – German insult; rascal.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lebensraum")]), _vm._v(" – Literally, living space, Hitler’s foreign policy for expanding the Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Machal")]), _vm._v(" – The Hebrew acronym for ‘Overseas Volunteers’; soldiers who fought for the new state of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Maurerschule")]), _vm._v(" – Builders’ school.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Muselmänner")]), _vm._v(" – Muslims (col. for starving camp inmates).")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Oberkapo")]), _vm._v(" – Chief "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kapo.")])]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Operation Barbarossa")]), _vm._v(" – Codename for German invasion of Russia.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Organisation")]), _vm._v(" – Slang for black market operations in the camps.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Piepels")]), _vm._v(" – Boys used for sex by camp guards and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kapos.")])]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Premiumschein")]), _vm._v(" – Ticket for canteen.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Rampe Kommando")]), _vm._v(" – Platform detachment.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Rapportführer")]), _vm._v(" – Sergeant Major, commander of Block.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Raus!")]), _vm._v(" – Out!")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Reichsfeldmarschall")]), _vm._v(" – German rank of Field Marshal.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Rottenführer")]), _vm._v(" – Nazi Party section leader.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Scheissjude")]), _vm._v(" – Racial insult (lit. ‘shit-Jew’).")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Schiffchen")]), _vm._v(" – Soft side-cap.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Schnell!")]), _vm._v(" – Quickly!")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Schutzhäftlinge")]), _vm._v(" – Political prisoners (lit. protective prisoners).")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shabbat")]), _vm._v(" – Jewish Sabbath.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sheitel")]), _vm._v(" – Traditional black wig worn by Jewish women.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shem Yisborach")]), _vm._v(" – Hebrew name for God.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sicherheitsdienst")]), _vm._v(" – German security service.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Smetana")]), _vm._v(" – Sour cream.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sonderausweis")]), _vm._v(" – Passes that stated you were essential to the war effort.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sonderbehandlung")]), _vm._v(" – Special treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sonderkommando")]), _vm._v(" – Special units; inmates who were forced to operate the gas chambers and crematoria.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Stahlhelmes")]), _vm._v(" – Steel helmets.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Stalags")]), _vm._v(" – Prisoner-of-war camp.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Steigers")]), _vm._v(" – Civilian engineers (see also "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Baumeisters")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Stiebel")]), _vm._v(" – Jewish prayer room.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Stube")]), _vm._v(" – Side room.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Stubendienst")]), _vm._v(" – Camp orderlies.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sturmabteilung")]), _vm._v(" – Brown Shirts.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sturmbrigade Dirlewanger")]), _vm._v(" – Notorious SS military unit composed of German prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Totenkopf")]), _vm._v(" – Death’s Head units of SS.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Treif")]), _vm._v(" – Non-kosher food.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Treuhänder")]), _vm._v(" – A trusty; trusted helper.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Umgeseidelt im Osten")]), _vm._v(" – Resettlement in the East.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Untermenschen")]), _vm._v(" – Literally, subhuman. A Nazi term for Jews.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Unteroffizier/Unterscharführer")]), _vm._v(" – Corporal (Army/SS).")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Volksdeutsche")]), _vm._v(" – Poles of German origin.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Vorarbeiter")]), _vm._v(" – Foreman.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Wehrmacht")]), _vm._v(" – Germany’s armed forces.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Winterhilfe")]), _vm._v(" – Contributions to help soldiers on the Eastern Front.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Yad Vashem – Holocaust History Museum in Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Yiddishkeit")]), _vm._v(" – Jewishness.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Zyklon B – Chemical compound used in the gas chambers.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c30e40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/glossary.vue
// module id = 72
// module chunks = 0